const accessAuth = {

    LOGIN: {
        path: '/login'
    },

    PARTICIPANT_SIGN_UP: {
        path: '/participant-sign-up'
    },

    ORGANIZATION_SIGN_UP: {
        path: '/organization-sign-up'
    },

    FORGOT_PASSWORD: {
        path: '/forgot-password'
    },

    UNKNOWN_PATH: {
        path: '*'
    },

    LANDING_PAGE: {
        path: '/'
    }

}

export default accessAuth;